import { Injectable } from "@angular/core";
import { Store, StoreConfig } from "@datorama/akita";
import { VoucherRedeemModel } from "../models/voucher-redeem.model";

export enum REDEMPTION_RESULT{
    EMPTY = 'cl.voucher.code.empty.text',
    SUCCESS = 'cl.voucher.process.code',
    FAILED = 'cl.voucher.redeem.error'
}

export interface VoucherState{
    voucher: VoucherRedeemModel | null;
    loading: boolean;
    resultMessage: REDEMPTION_RESULT | null;
    error: any;
}

const intitialState = { voucher: null, loading: false, resultMessage: null };

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'voucher' })
export class VoucherStore extends Store<VoucherState>{
    constructor(){
        super(intitialState);
    }
}